export const BILLING_ORIGIN = (import.meta.env.VITE_CUSTOMER_ORIGIN as string | undefined) || 'https://billing.future-demand.com';
export const SUPPORT_ORIGIN = (import.meta.env.VITE_SUPPORT_ORIGIN as string | undefined) || 'https://support.future-demand.com';
const FLAG = 'fd_customer_session';
export function isSupportHost(): boolean { return window.location.origin === SUPPORT_ORIGIN; }
export function hasCustomerSession(): boolean { return localStorage.getItem(FLAG) === '1'; }
export function markCustomerSession(active: boolean): void {
  if (active) localStorage.setItem(FLAG, '1'); else localStorage.removeItem(FLAG);
}
export function safeReturnPath(value: string | null, fallback = '/app'): string {
  if (!value || !value.startsWith('/') || value.startsWith('//') || /[\\\r\n\u0000-\u001f]/.test(value)) return fallback;
  const url = new URL(value, window.location.origin);
  return url.origin === window.location.origin ? url.pathname + url.search : fallback;
}
export function moduleUrl(module: 'billing' | 'support', orgId?: string, language = 'en', supportOrigin = SUPPORT_ORIGIN): string {
  const path = module === 'billing' ? '/app' : '/support';
  const url = new URL(`${path}${orgId ? `/org/${encodeURIComponent(orgId)}` : ''}`, module === 'billing' ? BILLING_ORIGIN : supportOrigin);
  url.searchParams.set('lang', language === 'de' ? 'de' : 'en');
  return url.toString();
}
export function portalHeaders(): HeadersInit { return { 'Content-Type': 'application/json', 'X-FD-Portal-Request': '1' }; }
